import { Injectable } from '@angular/core';
import { UpdatePassword } from './UpdatePassword';
import { ApiRouteConfig } from '../../config/api.route.config';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class AccountService {

  constructor(private httpClient: HttpClient, private config: ApiRouteConfig) {
  }

  public updatePasswordAndAgreeLicense(updatePassword: UpdatePassword) {
    return this.httpClient.post(this.config.UPDATE_PASSWORD, updatePassword);
  }

  public agreeLicenseOnly(confirmationCode: string) {
    return this.httpClient.get(this.config.getRouteWithInjectedParams(this.config.AGREE_LICENSE, [confirmationCode]));
  }

  public getLoginByConfirmationCode(confirmationCode: string) {
    return this.httpClient.get(this.config.GET_LOGIN_BY_CONFIRMATION_CODE + confirmationCode);
  }

  public forgotPassword(username: string) {
    return this.httpClient.post(this.config.ACCOUNT_FORGOT_PASSWORD, {"username": username});
  }

  public checkResetPasswordCode(resetPasswordCode: string) {
    return this.httpClient.post(this.config.ACCOUNT_VERIFY_RESET_PASSWORD_CODE, {"resetPasswordCode": resetPasswordCode});
  }

  public confirmForgotPassword(updatePassword: UpdatePassword) {
    return this.httpClient.post(this.config.ACCOUNT_CONFIRM_FORGOT_PASSWORD, updatePassword);
  }

  public resendConfirmationEmail(username: string) {
    return this.httpClient.post(this.config.ACCOUNT_RESEND_CONFIRMATION_EMAIL, {"username": username});
  }
}
